import React from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import dummy from "../assets/dummy_avatar.png";

function Template10() {
	const form = useSelector((state) => state.main.form);
	const styling = useSelector((state) => state.style.form);
	const socials = useSelector((state) => state.social);
	const cta = useSelector((state) => state.cta.form);
	const addons = useSelector((state) => state.addons.form);

	const amazonLinks = [
		[
			"https://www.linkpicture.com/q/amazon.png",
			"https://www.linkpicture.com/q/LPic61c72ee5c4f51725625525.png",
			"https://www.linkpicture.com/q/LPic61c72f1d82b59509850988.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c72f47d991d638593079.png",
			"https://www.linkpicture.com/q/LPic61c73194718f81991868379.png",
			"https://www.linkpicture.com/q/LPic61c732db747741102340802.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73398864491551462123.png",
			"https://www.linkpicture.com/q/LPic61c7320acd89c504189821.png",
			"https://www.linkpicture.com/q/LPic61c733ccda48f738881890.png",
		],
	];

	const appleLinks = [
		[
			"https://www.linkpicture.com/q/LPic61c7356d7a3931091271486.png",
			"https://www.linkpicture.com/q/LPic61c735b75ab32608126733.png",
			"https://www.linkpicture.com/q/LPic61c735ffc99c81242761188.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73640b03f7481822390.png",
			"https://www.linkpicture.com/q/LPic61c73669bb9a7549505552.png",
			"https://www.linkpicture.com/q/LPic61c7369e00c5a316256201.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73746adb9e1405034461.png",
			"https://www.linkpicture.com/q/LPic61c7377b59ba41750833455.png",
			"https://www.linkpicture.com/q/LPic61c737a4b618e2123844008.png",
		],
	];

	const googlePlayLinks = [
		[
			"https://www.linkpicture.com/q/LPic61c737f5c87ff1959582031.png",
			"https://www.linkpicture.com/q/LPic61c73819df424545351671.png",
			"https://www.linkpicture.com/q/LPic61c73840f37b5216050285.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c7385eeec741931092265.png",
			"https://www.linkpicture.com/q/LPic61c73880281e52017706700.png",
			"https://www.linkpicture.com/q/LPic61c738a0759151986169137.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c738c368f8246355125.png",
			"https://www.linkpicture.com/q/LPic61c738e736b7a1235322205.png",
			"https://www.linkpicture.com/q/LPic61c7390a9cc871438097435.png",
		],
	];

	const ebayLinks = [
		[
			"https://www.linkpicture.com/q/LPic61c73936e1a66484389759.png",
			"https://www.linkpicture.com/q/LPic61c7395a605701277959530.png",
			"https://www.linkpicture.com/q/LPic61c739766cdca1118276126.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73997ad8fa140348815.png",
			"https://www.linkpicture.com/q/LPic61c739b9232151909593612.png",
			"https://www.linkpicture.com/q/LPic61c739dd5edb21818358860.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73a0b4e438905758520.png",
			"https://www.linkpicture.com/q/LPic61c73b8ab52441244149469.png",
			"https://www.linkpicture.com/q/LPic61c73bae513001795233122.png",
		],
	];

	const googleBusinessLinks = [
		[
			"https://www.linkpicture.com/q/LPic61c73c217e5551881215780.png",
			"https://www.linkpicture.com/q/LPic61c73c5a83bc3840520486.png",
			"https://www.linkpicture.com/q/LPic61c73c7baeb72357276476.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73cc68d0621065273649.png",
			"https://www.linkpicture.com/q/LPic61c73d2089efa1187338636.png",
			"https://www.linkpicture.com/q/LPic61c73d4446ae2590280192.png",
		],
		[
			"https://www.linkpicture.com/q/LPic61c73d699b9221972266304.png",
			"https://www.linkpicture.com/q/LPic61c73d863882f1821101283.png",
			"https://www.linkpicture.com/q/LPic61c73dab396ae1601513345.png",
		],
	];

	let isEmpty = true;
	let dummySocials = [];
	isEmpty = Object.values(form).every((x) => x === null || x.length === 0);
	if (isEmpty) {
		dummySocials = [
			{
				socialID: "Facebook",
				website: "https://www.facebook.com",
				source: "https://i.ibb.co/SVYkgg7/facebook.png",
				value: "https://www.facebook.com",
			},
			{
				socialID: "Twitter",
				website: "https://www.twitter.com",
				source: "https://i.ibb.co/K6bf0BH/twitter.png",
				value: "https://www.twitter.com",
			},
			{
				socialID: "LinkedIn",
				website: "https://www.linkedin.com",
				source: "https://i.ibb.co/BrX7Cfv/linkedin.png",
				value: "https://www.linkedin.com",
			},
		];
	}

	return (
		<div
			className="template"
			style={{ paddingTop: "2em", lineHeight: "1.6" }}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
				}}
			>
				{/* Image */}

				<div
					style={{
						margin: "auto 0",
						padding: "0.5em",
					}}
				>
					{form.image && (
						<img
							alt="avatar"
							src={form.image}
							height={styling.avatarSize.toString() + "px"}
							style={{
								borderRadius: styling.avatarRadius,
								paddingTop: "0.3em",
							}}
						/>
					)}
					{isEmpty && (
						<img
							alt="avatar"
							src={dummy}
							height={styling.avatarSize.toString() + "px"}
							style={{
								borderRadius: styling.avatarRadius,
								paddingTop: "0.3em",
							}}
						/>
					)}

					{/* First and Last Name */}
					<div
						style={{
							color: styling.featureColor,
							fontFamily: styling.fontStyle,
							fontSize:
								(
									parseInt(styling.fontSize) + parseInt(2)
								).toString() + "px",
						}}
					>
						{!isEmpty && form.firstName + " " + form.lastName}
						{isEmpty && "John Doe"}
					</div>

					{/* Job Title */}
					<div
						style={{
							color: styling.textColor,
							fontFamily: styling.fontStyle,
							fontSize:
								parseInt(styling.fontSize).toString() + "px",
							lineHeight: 0.7,
						}}
					>
						{!isEmpty && form.jobTitle}
						{isEmpty && "Buisnessman"}
					</div>
				</div>
				<div
					style={
						form.image && {
							borderLeft: "4px solid " + styling.featureColor,
							paddingLeft: "0.5em",
						}
					}
				>
					{/* Job Department */}
					<div
						style={{
							color: styling.textColor,
							fontFamily: styling.fontStyle,
							fontSize:
								parseInt(styling.fontSize).toString() + "px",
						}}
					>
						{!isEmpty && form.department}
						{isEmpty && "Buiness dept"}
					</div>

					{/* Company Name */}
					<div
						style={{
							color: styling.textColor,
							fontFamily: styling.fontStyle,
							fontSize:
								parseInt(styling.fontSize).toString() + "px",
						}}
					>
						<strong>
							{!isEmpty && form.companyName}
							{isEmpty && "John Does Ltd"}
						</strong>
					</div>

					{/* Mobile and office phone */}
					<div>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.officePhone.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							P:{" "}
						</span>
						<span
							style={{
								color: styling.textColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.officePhone}
							{isEmpty && "41 123 245"}
						</span>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.mobileNumber.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							{" "}
							M:{" "}
						</span>
						<span
							style={{
								color: styling.textColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.mobileNumber}
							{isEmpty && "91 4123 9876"}
						</span>
					</div>

					{/* Fax  */}
					<div>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.officeFax.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							F:{" "}
						</span>
						<span
							style={{
								color: styling.textColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.officeFax}
							{isEmpty && "41 123 567"}
						</span>
					</div>

					{/* Address Line 1 */}
					<div>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.address.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							A:{" "}
						</span>
						<span
							style={{
								color: styling.textColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.address}
							{isEmpty && "5 Something St"}
						</span>
					</div>

					{/* Address Line 2 */}
					<div>
						<span
							style={{
								color: "white",
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.addressLine2.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							A:{" "}
						</span>
						<span
							style={{
								color: styling.textColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.addressLine2}
							{isEmpty && "Somewhere NSW 2000"}
						</span>
					</div>

					{/* Website */}
					<div>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.website.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							W:{" "}
						</span>
						<span
							style={{
								color: styling.linkColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							<a
								href={form.website}
								style={{ textDecoration: "none" }}
							>
								{!isEmpty && form.website}
								{isEmpty && "www.john-does.com"}
							</a>
						</span>
					</div>

					{/* Email */}
					<div>
						<span
							style={{
								color: styling.featureColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
								display:
									parseInt(form.email.length) === 0 &&
									!isEmpty &&
									"none",
							}}
						>
							E:{" "}
						</span>
						<span
							style={{
								color: styling.linkColor,
								fontFamily: styling.fontStyle,
								fontSize:
									parseInt(styling.fontSize).toString() +
									"px",
							}}
						>
							{!isEmpty && form.email}
							{isEmpty && "johndoe@example.com"}
						</span>
					</div>

					{/* Additional Fields */}

					{form.additionalField.map((eachField) => (
						<div>
							{(eachField.fieldType === "Text" ||
								eachField.fieldType === "Phone") && (
								<div>
									<span
										style={{
											color: styling.featureColor,
											fontFamily: styling.fontStyle,
											fontSize:
												parseInt(
													styling.fontSize
												).toString() + "px",
										}}
									>
										{eachField.fieldName + ": "}
									</span>
									<span
										style={{
											color: styling.textColor,
											fontFamily: styling.fontStyle,
											fontSize:
												parseInt(
													styling.fontSize
												).toString() + "px",
										}}
									>
										{eachField.fieldValue}
									</span>
								</div>
							)}
							{eachField.fieldType === "Link" && (
								<div>
									<span
										style={{
											color: styling.featureColor,
											fontFamily: styling.fontStyle,
											fontSize:
												parseInt(
													styling.fontSize
												).toString() + "px",
										}}
									>
										{eachField.fieldName + ": "}
									</span>

									<span
										style={{
											color: styling.textColor,
											fontFamily: styling.fontStyle,
											fontSize:
												parseInt(
													styling.fontSize
												).toString() + "px",
										}}
									>
										<a
											style={{
												color: styling.linkColor,
												textDecoration: "none",
											}}
											href={eachField.fieldValue}
										>
											{eachField.fieldValue}
										</a>
									</span>
								</div>
							)}
						</div>
					))}

					{/* Socials  */}
					<div
						className="icons"
						style={{ display: "flex", flexDirection: "row" }}
					>
						{isEmpty &&
							dummySocials.map((social) => (
								<a href={social.value}>
									<img
										alt="social"
										src={social.source}
										key={social.socialID}
										style={{
											height: styling.iconSize,
											width: styling.iconSize,
											margin: "2px",
											borderRadius:
												(styling.iconShape == 2 &&
													"15%") ||
												(styling.iconShape == 3 &&
													"50%"),
										}}
									></img>
								</a>
							))}
						{!isEmpty &&
							socials.selected.map((social) => (
								<a
									href={social.value}
									style={{
										display:
											parseInt(social.value.length) ===
												0 && "none",
									}}
								>
									<img
										alt="social"
										src={social.source}
										key={social.socialID}
										style={{
											height: styling.iconSize,
											width: styling.iconSize,
											margin: "2px",
											borderRadius:
												(styling.iconShape == 2 &&
													"15%") ||
												(styling.iconShape == 3 &&
													"50%"),
										}}
									></img>
								</a>
							))}
					</div>

					{/* CTA */}

					<div>
						{cta.image && cta.imageView && (
							<a
								href={cta.link.length === 0 ? "#" : cta.link}
								rel="noopener noreferrer"
								target="_blank"
							>
								<img
									alt={cta.altText}
									src={cta.image}
									height={styling.ctaImageSize}
									style={{
										borderRadius: styling.ctaImageRadius,
										paddingTop: "0.3em",
									}}
								/>
							</a>
						)}

						{!cta.imageView && cta.text.length > 0 && (
							<Button
								style={{
									backgroundColor: cta.backgroundColor,
									color: cta.textColor,
									borderRadius: "25px",
									fontSize:
										parseInt(cta.textSize - 2).toString() +
										"px",
									fontFamily: styling.fontStyle,
									fontStyle: cta.textStyle,
									fontWeight: cta.textStyle,
									padding: "0.6em",
								}}
							>
								{cta.text}
							</Button>
						)}
					</div>
				</div>
			</div>

			{/* Badges */}

			<div>
				{addons.amazonBadge.length > 0 && (
					<a
						href={addons.amazonBadge}
						rel="noopener noreferrer"
						target="_blank"
						style={{
							paddingTop: addons.badgePaddingTop,
							paddingLeft: "0.5em",
						}}
					>
						<img
							alt="badgeImage"
							src={
								amazonLinks[addons.badgeShape - 1][
									addons.badgeColor - 1
								]
							}
							height={addons.badgeHeight}
						/>
					</a>
				)}
				{addons.appleBadge.length > 0 && (
					<a
						href={addons.appleBadge}
						rel="noopener noreferrer"
						target="_blank"
						style={{
							paddingTop: addons.badgePaddingTop,
							paddingLeft: "0.5em",
						}}
					>
						<img
							alt="badgeImage"
							src={
								appleLinks[addons.badgeShape - 1][
									addons.badgeColor - 1
								]
							}
							height={addons.badgeHeight}
						/>
					</a>
				)}
				{addons.ebayBadge.length > 0 && (
					<a
						href={addons.ebayBadge}
						rel="noopener noreferrer"
						target="_blank"
						style={{
							paddingTop: addons.badgePaddingTop,
							paddingLeft: "0.5em",
						}}
					>
						<img
							alt="badgeImage"
							src={
								ebayLinks[addons.badgeShape - 1][
									addons.badgeColor - 1
								]
							}
							height={addons.badgeHeight}
						/>
					</a>
				)}
				{addons.googlePlayBadge.length > 0 && (
					<a
						href={addons.googlePlayBadge}
						rel="noopener noreferrer"
						target="_blank"
						style={{
							paddingTop: addons.badgePaddingTop,
							paddingLeft: "0.5em",
						}}
					>
						<img
							alt="badgeImage"
							src={
								googlePlayLinks[addons.badgeShape - 1][
									addons.badgeColor - 1
								]
							}
							height={addons.badgeHeight}
						/>
					</a>
				)}
				{addons.googleBusinessBadge.length > 0 && (
					<a
						href={addons.googleBusinessBadge}
						rel="noopener noreferrer"
						target="_blank"
						style={{
							paddingTop: addons.badgePaddingTop,
							paddingLeft: "0.5em",
						}}
					>
						<img
							alt="badgeImage"
							src={
								googleBusinessLinks[addons.badgeShape - 1][
									addons.badgeColor - 1
								]
							}
							height={addons.badgeHeight}
						/>
					</a>
				)}
			</div>

			{/* Addons */}
			<div>
				<span
					style={{
						color: "grey",
						fontFamily: styling.fontStyle,
						fontSize: parseInt(addons.fontSize).toString() + "px",
					}}
				>
					<p
						style={{
							whiteSpace: "break-spaces",
							width:
								addons.width == "none"
									? "auto"
									: parseInt(addons.width).toString() + "px",
							textOverflow: "ellipsis",
							overflow: "hidden",
							lineHeight: "100%",
						}}
					>
						{addons["data"][addons.selected]["content"]}
					</p>
				</span>
			</div>
			<div
				style={{
					borderTop: "1px solid #CCCCCC",
					width: "35%",
					fontSize: "8px",
					fontWeight: "600",
					padding: "4px",
				}}
			>
				Create your own{" "}
				<a href="https://www.seohorizon.com/email-signature-generator/" style={{ color: "#0385DB" }}>
					email signature
				</a>
			</div>
		</div>
	);
}

export default Template10;
